import Container from 'typedi'
import { VuexModule, Module, Action } from 'vuex-module-decorators'
import RegistrationLinkService from '../services/registration-link.service'

@Module({
  namespaced: true
})
export default class RegistrationLinkStore extends VuexModule {

  @Action({ rawError: true })
  async validateRegistrationLink (payload: any) {
    const { event_identifier, registration_link } = payload
    const response = await Container.get(RegistrationLinkService).validateRegistrationLink(event_identifier, registration_link)
    return response
  }
}
